export const faq = {
  "faq.title": "Frequently Asked Questions",
  "faq.subtitle": "Quickly find answers to your questions about Suji",
  "faq.search_placeholder": "Search in FAQ...",
  "faq.search_results": "Search results",
  "faq.no_results": "No results found",
  "faq.try_keywords": "Try with different keywords",
  "faq.not_found_title": "Can't find your answer?",
  "faq.not_found_text": "Our support team is here to help. Contact us and we'll respond quickly.",
  "faq.contact_us": "Contact us",
  "faq.live_chat": "Live chat",
  
  // Categories
  "faq.cat_general": "General",
  "faq.cat_buyers": "For buyers",
  "faq.cat_suppliers": "For suppliers",
  "faq.cat_technical": "Technical",
  
  // General Questions
  "faq.general.q1": "What is Suji?",
  "faq.general.a1": "Suji is a geo-located search engine that allows you to easily find all suppliers in Nigeria. Our platform connects businesses with the best local suppliers in all categories.",
  "faq.general.q2": "How to use Suji?",
  "faq.general.a2": "Simply enter what you are looking for in the search bar, specify your location and choose a category if necessary. Our results are sorted by relevance and geographical proximity.",
  "faq.general.q3": "Is Suji free?",
  "faq.general.a3": "Yes, searching for suppliers on Suji is completely free. Suppliers can also create a basic profile for free.",
  
  // Buyer Questions
  "faq.buyers.q1": "How to contact a supplier?",
  "faq.buyers.a1": "On each supplier's detail page, you will find their contact information: phone, email, and a direct contact form. You can also use our AI assistant to schedule an appointment.",
  "faq.buyers.q2": "How to verify a supplier's reliability?",
  "faq.buyers.a2": "We verify all our partner suppliers. Look for the \"Verified\" badge on their profile. You can also check reviews and ratings left by other customers.",
  "faq.buyers.q3": "Can I filter results by distance?",
  "faq.buyers.a3": "Yes, you can set a search radius (10, 25, 50 or 100 km) to find suppliers closest to your location.",
  
  // Supplier Questions
  "faq.suppliers.q1": "How to add my business to Suji?",
  "faq.suppliers.a1": "Click on \"Add your business\" in the main menu, then create your account and fill in your business information. Creating a basic profile is free.",
  "faq.suppliers.q2": "How to get the \"Verified\" badge?",
  "faq.suppliers.a2": "After creating your profile, our team will verify your business information. This process usually takes 2-3 business days. You will receive a notification once verification is complete.",
  "faq.suppliers.q3": "Can I modify my information after registration?",
  "faq.suppliers.a3": "Yes, you can modify all your information from your supplier dashboard. Major changes may require re-verification.",
  "faq.suppliers.q4": "How to improve my business visibility?",
  "faq.suppliers.a4": "Complete your profile fully, add quality photos, encourage your customers to leave reviews, and keep your information up to date. We also offer premium options for more visibility.",
  
  // Technical Questions
  "faq.technical.q1": "On which devices can I use Suji?",
  "faq.technical.a1": "Suji works on all devices: computers, tablets and smartphones. Our website is optimized for all modern browsers.",
  "faq.technical.q2": "Is my personal data secure?",
  "faq.technical.a2": "Yes, we take security very seriously. All your data is encrypted and we strictly comply with data protection regulations.",
  "faq.technical.q3": "What to do if I encounter a technical problem?",
  "faq.technical.a3": "Contact our technical support via the Contact page or use our AI assistant. We usually respond within 24 hours."
};

export default faq;
